module.exports = __webpack_public_path__ + "img/glass.3c8704a.svg?v=1763034624171";